export default "__VITE_ASSET__D9Wj5POf__"